import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.9, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);

export const MaskedLines = ({ lines, className = "", lineClassName = "", accentLast = false, delay = 0.2 }) => (
    <span className={`block ${className}`}>
        {lines.map((line, i) => (
            <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
                <motion.span
                    className={`block ${lineClassName} ${accentLast && i === lines.length - 1 ? "italic text-gold" : ""}`}
                    initial={{ y: "112%" }}
                    animate={{ y: 0 }}
                    transition={{ duration: 1.15, delay: delay + i * 0.16, ease: EASE }}
                >
                    {line}
                </motion.span>
            </span>
        ))}
    </span>
);

export const Overline = ({ children, className = "" }) => (
    <p className={`overline-label ${className}`}>{children}</p>
);

export const Chapter = ({ number, label, dark = false }) => (
    <Reveal y={16}>
        <div className="flex items-center gap-5">
            <span className="font-serif text-xl italic leading-none text-gold">{number}</span>
            <span className={`h-px w-12 ${dark ? "bg-gold/60" : "bg-gold/70"}`} />
            <span className={`text-[11.5px] font-medium uppercase tracking-[0.3em] ${dark ? "text-ivory/70" : "text-ink/60"}`}>
                {label}
            </span>
        </div>
    </Reveal>
);
